import { useMemo } from 'react'

import { getBrand } from 'pared/utils/brand'

import { IPropsType as IFeV2ChatBoxPropsType } from '../../../Routes/renderer/feV2ChatBox'

interface IConfig extends Omit<IFeV2ChatBoxPropsType, 'type'> {
  enableChat: boolean
}

const defaultConfig: IConfig = {
  enableChat: false,
  agentType: 'location',
  description: 'Ask about guest satisfaction',
  sendStoreId: true,
}

export default (): IConfig => {
  const brand = getBrand()

  return useMemo(() => {
    switch (brand) {
      case 'sullivans':
      case 'sullivans_nso':
      case 'eddiemerlots':
      case 'eddiemerlots_nso':
        return {
          ...defaultConfig,
          enableChat: true,
          hideFromNonExpoUsers: false,
          disableInputField: true,
          bubblePrompts: [
            {
              id: 'guest-satisfaction',
              label: 'Summarize Guest Satisfaction',
              prompt: 'Show me the guest satisfaction for the trailing 8 weeks',
              params: {
                type: 'dateRange',
                dateRangeType: 'trailing_8weeks',
                periods: ['current'],
              },
              agentCode: 'prompt:guest-satisfaction',
              metrics: ['guest_avg_rating_score_momentfeed'],
            },
          ],
        }

      default:
        return defaultConfig
    }
  }, [brand])
}
